(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-load-signup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('page-load-modal')) {
    customElements.define(
      'page-load-modal',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('dialog');
          if (!this.dialog) return;
          this.content = this.querySelector('.signup-modal__content');
          this.key = 'signup-modal:' + this.dataset.sectionId;

          this.querySelectorAll('[data-close]').forEach((el) => el.addEventListener('click', () => this.close()));

          if (this.dataset.closeOnOverlay === 'true') {
            this.dialog.addEventListener('click', (e) => {
              const r = this.content.getBoundingClientRect();
              if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) this.close();
            });
          }

          // Always preview in the theme editor (ignoring frequency + trigger).
          if (window.Shopify && window.Shopify.designMode) {
            this.arm('delay');
            return;
          }
          if (!this.shouldShow()) return;
          this.arm(this.dataset.trigger);
        }

        disconnectedCallback() {
          this.cleanup();
        }

        arm(trigger) {
          const delay = (parseInt(this.dataset.delay, 10) || 0) * 1000;

          if (trigger === 'scroll') {
            const pct = (parseInt(this.dataset.scroll, 10) || 30) / 100;
            this.onScroll = () => {
              const max = document.documentElement.scrollHeight - window.innerHeight;
              if (max <= 0 || window.scrollY / max >= pct) this.open();
            };
            window.addEventListener('scroll', this.onScroll, { passive: true });
            this.onScroll();
          } else if (trigger === 'exit_intent') {
            // No hover on touch devices — fall back to the delay.
            if (window.matchMedia('(hover: none)').matches) {
              this.timer = setTimeout(() => this.open(), delay);
              return;
            }
            this.onExit = (e) => {
              if (e.clientY <= 0 && !e.relatedTarget) this.open();
            };
            document.addEventListener('mouseout', this.onExit);
          } else {
            this.timer = setTimeout(() => this.open(), delay);
          }
        }

        open() {
          if (this.dialog.open) return;
          this.cleanup();
          this.dialog.showModal();
          this.record();
        }

        close() {
          if (this.dialog.open) this.dialog.close();
        }

        cleanup() {
          clearTimeout(this.timer);
          if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
          if (this.onExit) document.removeEventListener('mouseout', this.onExit);
        }

        shouldShow() {
          const freq = this.dataset.frequency;
          const days = parseInt(this.dataset.days, 10) || 0;
          try {
            if (freq === 'every_visit') return true;
            if (freq === 'session') return !sessionStorage.getItem(this.key);
            if (freq === 'once') return !localStorage.getItem(this.key);
            if (freq === 'days') {
              const last = parseInt(localStorage.getItem(this.key), 10);
              return !last || Date.now() - last > days * 86400000;
            }
          } catch (e) {
            return true;
          }
          return true;
        }

        record() {
          if (window.Shopify && window.Shopify.designMode) return;
          const freq = this.dataset.frequency;
          try {
            if (freq === 'session') sessionStorage.setItem(this.key, '1');
            else if (freq === 'once') localStorage.setItem(this.key, '1');
            else if (freq === 'days') localStorage.setItem(this.key, Date.now().toString());
          } catch (e) {}
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
